import { STATS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const TrustBar = () => (
  <section className="mx-auto max-w-7xl px-5 py-14 lg:px-8" data-testid="trust-bar">
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.08}>
          <div className="rounded-2xl border border-xmove-ink/8 bg-white p-6 text-center shadow-soft">
            <div className="font-display text-3xl font-bold text-xmove-orange sm:text-4xl">{s.value}</div>
            <div className="mt-1.5 text-xs font-medium uppercase tracking-wider text-xmove-muted sm:text-sm">{s.label}</div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
